import {IPrTireLoadImperial, IPrTireLoadMetric} from "@/modules/perRoad/interfaces/monteCarlo";
import {UnitSystem} from "@/interfaces/units";

export const getContactPatchRadius = (load: IPrTireLoadImperial | IPrTireLoadMetric): number => {
  if (load.unitSystem === UnitSystem.Imperial) {
    return Number(Math.sqrt(load.load_lbf / (Math.PI * load.tirePressure_psi)).toFixed(2));
  } else {
    return Number(Math.sqrt(load.load_kg * 9.81 / (Math.PI * load.tirePressure_mpa * 1000000)).toFixed(2)) ;
  }
};
